import { useEffect, useState } from "react";
import { InactivePrimaryButton, PrimaryButton, SecondaryButton } from "./Buttons";
import { Link } from 'react-router-dom';

const AddReview = ({ click, shopId }) => {

    // HANDLE INPUT DATA
    const initialState = {
        shopId: shopId,
        name: '',
        surname: '',
        review: '',
        rating: null
    }
    const [inputData, setInputData] = useState(initialState);

    const handleInputData = (event) => {
        const { id, value } = event.target;
        setInputData(prevInputData => ({
            ...prevInputData,
            [id]: value
        }))
    }

    useEffect(() => {
        console.log('inputData: ', inputData)
    }, [inputData])

    // HANDLE STARS
    const [rating, setRating] = useState(null);
    useEffect(() => {
        setInputData(prevInputData => ({
            ...prevInputData,
            rating: rating
        }))
    }, [rating])

    // SEND REVIEW FETCH
    const [fetchStatus, setFetchStatus] = useState('idle');

    const sendData = async () => {
        setFetchStatus('loading')
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/shops/add-rating`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(inputData)
            });
            if(response.ok){
                const result = await response.json();
                console.log('Fetch eseguita con successo'); // aggiungere messaggio utente
                setFetchStatus('succeeded');
            } else {
                throw new Error("Errore durante l'invio dei dati. Riprova.");
                setFetchStatus('error');
            }
        } catch (error) {
            console.error('Errore: ', error)
            setFetchStatus('error');
        }
    }

    useEffect(() => {
        console.log('ADDREVIEW fetchStatus: ', fetchStatus)
    }, [fetchStatus])

    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 bg-white z-10 p-12 flex flex-col items-center justify-start gap-4">
            <i class="fi fi-rr-cross-circle text-4xl cursor-pointer text-orange-500" onClick={click}></i>
            <h3>Scrivi una recensione</h3>
            <p className="text-center">La tua recensione deve essere riferita esclusivamente al servizio di spiedo da asporto e non sugli altri servizi di ristorazione e vendita del negozio.</p>
            <div className='flex flex-col items-center gap-2 md:ml-0'>
                <label htmlFor="name">Nome</label>
                <input id="name" type="text" className="w-48" onChange={handleInputData} />
                <label htmlFor="surname">Cognome</label>
                <input id="surname" type="text" className="w-48" onChange={handleInputData} />
                <label htmlFor="review">Recensione</label>
                <textarea id="review" className="p-2 border border-cyan-600 rounded-lg w-96 md:w-96 h-48 resize-none" onChange={handleInputData} ></textarea>

                <label htmlFor="stars">Quante stelle daresti?</label>
                <div className="flex gap-1">
                    <div className={`flex w-12 h-12 border-2 border-orange-500 rounded-[24px] hover:bg-orange-500 cursor-pointer justify-center items-center ${rating === 1 ? 'bg-orange-500' : ''}`} onClick={() => setRating(1)}>1</div>
                    <div className={`flex w-12 h-12 border-2 border-orange-500 rounded-[24px] hover:bg-orange-500 cursor-pointer justify-center items-center ${rating === 2 ? 'bg-orange-500' : ''}`} onClick={() => setRating(2)}>2</div>
                    <div className={`flex w-12 h-12 border-2 border-orange-500 rounded-[24px] hover:bg-orange-500 cursor-pointer justify-center items-center ${rating === 3 ? 'bg-orange-500' : ''}`} onClick={() => setRating(3)}>3</div>
                    <div className={`flex w-12 h-12 border-2 border-orange-500 rounded-[24px] hover:bg-orange-500 cursor-pointer justify-center items-center ${rating === 4 ? 'bg-orange-500' : ''}`} onClick={() => setRating(4)}>4</div>
                    <div className={`flex w-12 h-12 border-2 border-orange-500 rounded-[24px] hover:bg-orange-500 cursor-pointer justify-center items-center ${rating === 5 ? 'bg-orange-500' : ''}`} onClick={() => setRating(5)}>5</div>
                </div>
            </div>
            {
                fetchStatus === 'idle' ? (
                    (inputData.name !== '' && inputData.surname !== '' && inputData.review !== '' && inputData.rating !== null) ? (
                        <PrimaryButton text="Invia recensione" click={sendData} />
                    ) : (
                        <InactivePrimaryButton text="Invia recensione" />
                    )
                ) : (
                    fetchStatus === 'loading' ? (
                        <div className="custom-loader"></div>
                    ) : (
                        fetchStatus === 'error' ? (
                            <h3>Qualcosa è andato storto, ricarica la pagina e riprova.</h3>
                        ) : (
                            fetchStatus === 'succeeded' && 
                            <div className="w-full flex flex-col items-center gap-2">
                                <h4>Recensione inserita correttamente.</h4>
                                <SecondaryButton text="Torna alla homepage" click={() => window.location.reload()} />
                                </div>
                        )
                    )
                )
            }
            
        </div>
    )
}

export default AddReview;